import { Col, Table, TableActionBarRow } from "melco-ui";
import { useTranslation } from "react-i18next";
import { MelcoModelsUserListItem } from "melco-shared-logic";
import { TableCellLink } from "../table/TableCellLink";
import { useUsers } from "../../hooks/users/useUsers";
import { UsersListFilter } from "./UsersListFilter";
import { UserAddProfileDrawer } from "./drawer/UserAddProfileDrawer";
import { MASTER, SUB_USER } from "../../helper/usersHelper";

type UsersListPropTypes = {
  setIsAddProfileDrawerOpenFunction: (v: boolean) => void;
  isAddProfileDrawerOpen: boolean;
};
const DETAIL_VIEW_PATH = "/users";

export const UsersList: React.FC<UsersListPropTypes> = ({
  isAddProfileDrawerOpen,
  setIsAddProfileDrawerOpenFunction,
}) => {
  const { t } = useTranslation();

  const {
    isLoading,
    isFetching,
    data,
    isPreviousData,
    errorComponent,
    onTableConfigChange,
    filtersChange,
  } = useUsers();

  const columns = [
    {
      title: t("users.table.column.id"),
      key: "id",
      width: 145,
      sorter: true,
      render: (rowObj: MelcoModelsUserListItem) => {
        let parent_user_id = rowObj?.parent_user_id ?? "";
        let subUserFlag = parent_user_id != "" ? true : false;
        return subUserFlag ? (
          <TableCellLink
            // to={[DETAIL_VIEW_PATH, 'subuser', rowObj.id].join("/")}
            to=""
            onClick={() => {
              alert("SubUser Functionality Under Process");
            }}
          >
            {rowObj.id}
          </TableCellLink>
        ) : (
          <TableCellLink
            onClick={() => {
              //                    handleEditClick(rowObj)
            }}
            to={[DETAIL_VIEW_PATH, rowObj.id].join("/")}
          >
            {rowObj.id}
          </TableCellLink>

        );
      },
    },
    {
      title: t("users.table.column.customer_id"),
      key: "melco_customer_id",
      width: 145,
      dataIndex: "melco_customer_id",
      sorter: true,
    },
    {
      title: t("users.table.column.type"),
      key: "parent_user_id",
      sorter: true,
      width: 85,
      render: (rowObj: MelcoModelsUserListItem) => {
        let parent_user_id = rowObj?.parent_user_id ?? "";

        let subUserFlag = parent_user_id != "" ? true : false;
        return subUserFlag
          ? // <TableCellLink onClick={() => {
          //     //                    handleEditClick(rowObj)
          // }} to={[DETAIL_VIEW_PATH, parent_user_id].join("/")}>
          SUB_USER
          : // </TableCellLink>
          MASTER;
      },
    },
    {
      title: t("users.table.column.account_name"),
      key: "account_name",
      width: 135,
      dataIndex: "account_name",
      sorter: true,
    },
    {
      title: t("users.table.column.first_name"),
      key: "first_name",
      width: 135,
      dataIndex: "first_name",
      sorter: true,
    },
    {
      title: t("users.table.column.last_name"),
      key: "last_name",
      width: 125,
      dataIndex: "last_name",
      sorter: true,
    },
    {
      title: t("users.table.column.created"),
      key: "created_on",
      width: 110,
      render: (rowObj: MelcoModelsUserListItem) => (
        <div>
          <span>
            {rowObj.created_on
              ? new Date(rowObj.created_on).toLocaleString()
              : ""}
          </span>
        </div>
      ),
      sorter: true,
    },
    {
      title: t("users.table.column.verified"),
      key: "verified_on",
      width: 110,
      sorter: true,
      render: (rowObj: MelcoModelsUserListItem) => (
        <div>
          <span>
            {rowObj.verified_on
              ? new Date(rowObj.verified_on).toLocaleString()
              : ""}
          </span>
        </div>
      ),
    },
    {
      title: t("users.table.column.country"),
      key: "country_code",
      width: 80,
      dataIndex: "country_code",
      sorter: true,
    },
    {
      title: t("users.table.column.state"),
      key: "state_code",
      width: 80,
      dataIndex: "state_code",
      sorter: true,
    },
  ];

  const closeAllDrawerAction = () => {
    setIsAddProfileDrawerOpenFunction(false);
  };

  return (
    <>
      <TableActionBarRow>
        <Col>
          <UsersListFilter onFiltersChange={filtersChange} />
        </Col>
      </TableActionBarRow>
      <Table
        showSorterTooltip={false}
        sticky
        loading={isPreviousData ? isFetching : isLoading}
        dataSource={data}
        columns={columns}
        onChange={onTableConfigChange}
        pagination={false}
        rowKey="id"
        //rowSelection={rowSelection}
        // onRow={onRow}
        noDataMessage={t("users.table.no_data_message")}
        errorComponent={errorComponent}
      />

      {isAddProfileDrawerOpen && (
        <UserAddProfileDrawer
          isAddProfileDrawerOpen={isAddProfileDrawerOpen}
          closeAllDrawerAction={() => {
            closeAllDrawerAction();
          }}
        />
      )}
    </>
  );
};
